import React from 'react';

import MoreHorizontalIcon from './assets/more-horizontal.svg';
import WorkspaceLogo from './assets/workspace-logo.svg';
import * as S from './LandingPageHeader.styles';

export interface Tab {
  id: string;
  label: string;
  isActive?: boolean;
}

export interface LandingPageHeaderProps {
  tabs: Tab[];
  onTabClick?: (tabId: string) => void;
  onMoreClick?: () => void;
}

export const LandingPageHeader: React.FC<LandingPageHeaderProps> = ({
  tabs,
  onTabClick,
  onMoreClick,
}) => {
  const handleTabClick = (tabId: string) => {
    onTabClick?.(tabId);
  };

  return (
    <S.Header>
      <S.HeaderContent>
        <S.Logo>
          <WorkspaceLogo aria-label="LSEG Alfred Workspace" />
        </S.Logo>
        <S.TitleAndTabs>
          <S.Title>LSEG Workspace</S.Title>
          <S.TabList>
            {tabs.map(tab => (
              <S.Tab
                key={tab.id}
                $isActive={tab.isActive}
                onClick={() => handleTabClick(tab.id)}
              >
                {tab.label}
              </S.Tab>
            ))}
          </S.TabList>
        </S.TitleAndTabs>
        <S.MoreButton onClick={onMoreClick} aria-label="More options">
          <S.MoreIcon>
            <MoreHorizontalIcon />
          </S.MoreIcon>
        </S.MoreButton>
      </S.HeaderContent>
    </S.Header>
  );
};
